import { throwErrorMsg } from "../../utils/throwErrorMsg"

export const permission = {
  // 判断Android权限
  isGranted(file: string | string[] = "") {
    throwErrorMsg('permission.isGranted')
  },
  request(permissions: string | string[] = "") {
    throwErrorMsg('permission.request')
  }
} as PermissionDSL